import { jsx as _jsx } from "react/jsx-runtime";
import { uploadMissionImage } from '../../api/mission-images';
import { EntityBulkUploadModal } from '../EntityBulkUploadModal/EntityBulkUploadModal';
export const MissionsBulkUploadModal = (props) => (_jsx(EntityBulkUploadModal, Object.assign({}, props, { title: "Bulk Upload Mission Images", upload: uploadMissionImage, uploadView: "compact", resultView: "fileList" })));
